import { gql } from '@apollo/client';

const getAllInvoicesQueries = gql `
  query (
    $orgID: UUID1!
    $filter: OrderActivityFilters
    $limit: Int!
    $offset: Int!
  ) {
    getAllInvoices(
      orgID: $orgID
      filter: $filter
      limit: $limit
      offset: $offset
    ) {
      count
      data {
        id
        createdAt
        isSecondary
        userID
        status
        totalPrice
        PriceCrypto
        usdItemPrice
        quantity
        transactionHash
        invoiceID
        invoiceNumber
        itemID
        tokenID
        contractAddress
        onChainTokenID
        networkID
        eventType
        fromWalletAddress
        toWalletAddress
        image
        itemName
      }
    }
  }
`;

export { getAllInvoicesQueries };
